export default "__VITE_ASSET__CcIU34XY__"